export class SignupForm<T> {
  value: T;
  key: string;
  label: string;
  required: boolean;
  controlType: string;
  pattern: string;
  vals: { key: string; value: string }[] = [];
  valid: string;
  errors: any;

  constructor(
    options: {
      value?: T;
      key?: string;
      label?: string;
      required?: boolean;
      controlType?: string;
      pattern?: string;
      vals?: any;
      valid?: string;
      errors?: any;
    } = {}
  ) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.controlType = options.controlType || '';
    this.pattern = options.pattern || '';
    this.vals = options.vals || [];
    this.valid = options.valid || 'VALID';
    this.errors = options.errors || {};
  }
}



// WEBPACK FOOTER //
// ./src/app/components/signup/signup-form.ts